import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=6a2c7a8b&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=ts"
export * from "./confirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c7a8b",
  null
  
)

export default component.exports